// Global Instructions Rule Applied!
import FileIcon from './FileIcon.tsx'
import { FILE_TYPE, URL_TYPE } from '../../../../state_manager/constants/files.ts'
import type { ColumnsType } from 'antd/es/table'

interface FileRecord {
  key: string
  name: string
  type: typeof FILE_TYPE | typeof URL_TYPE
  uploadDate: string
  file_path: string | null
  url: string | null
}

interface FileTableColumnsProps {
  onFileClick: (filePathOrUrl: string, fileName: string, isUrl?: boolean) => void
}

const FileTableColumns = ({ onFileClick }: FileTableColumnsProps): ColumnsType<FileRecord> => {
  return [
    {
      title: '',
      key: 'icon',
      width: 40,
      align: 'center',
      render: (_, record) => <FileIcon type={record.type} />
    },
    {
      title: 'File Name',
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: FileRecord) => {
        if (record.type === FILE_TYPE && record.file_path) {
          return (
            <button
              onClick={() => onFileClick(record.file_path!, text, false)}
              className='text-blue-600 hover:text-blue-800 hover:underline cursor-pointer bg-transparent border-none p-0 text-left'
            >
              {text}
            </button>
          )
        } else if (record.type === URL_TYPE && record.url) {
          return (
            <button
              onClick={() => onFileClick(record.url!, text, true)}
              className='text-blue-600 hover:text-blue-800 hover:underline cursor-pointer bg-transparent border-none p-0 text-left'
            >
              {text}
            </button>
          )
        }
        return <span>{text}</span>
      }
    },
    {
      title: 'Upload Date',
      dataIndex: 'uploadDate',
      key: 'uploadDate',
      render: (text: string) => (text ? <span>{text}</span> : <span className='text-gray-400'>-</span>)
    }
  ]
}

export default FileTableColumns
